export default __webpack_public_path__ + "static/media/luggage2.9b87fafd.png";